export default __webpack_public_path__ + "6bcad17743d26347712269c4a74bdb90.png";